import type { ReactNode } from "react";
import { CircleHelp } from "lucide-react";

/** 帮助图标：悬停 / 聚焦展示操作说明，不占正文位。 */
export function HelpHint({
  children,
  label = "说明",
  className,
}: {
  children: ReactNode;
  label?: string;
  className?: string;
}) {
  if (children == null || children === false || children === "") return null;
  return (
    <span className={`page-help${className ? ` ${className}` : ""}`}>
      <button
        type="button"
        className="page-help-trigger"
        aria-label={label}
      >
        <CircleHelp size={16} strokeWidth={2} aria-hidden />
      </button>
      <span className="page-help-tip" role="tooltip">
        {children}
      </span>
    </span>
  );
}
